import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  Inject,
  forwardRef
} from '@angular/core';
import { connectConfigure } from 'instantsearch.js/es/connectors';
import { NgAisInstantSearch, BaseWidget } from 'angular-instantsearch';
import { SearchParameters } from '@app/core/search/common';

@Component({
  selector: 'vc-catalog-state',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogStateComponent extends BaseWidget implements OnInit, OnChanges {
  @Input()
  searchParameters: SearchParameters = {};

  public state: {
    refine: (value: Object) => void;
  };

  constructor(@Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent: NgAisInstantSearch) {
    super('CatalogConfigComponent');
  }

  getHelper(): any {
    return this.instantSearchParent.instantSearchInstance.helper;
  }

  ngOnInit(): void {
    this.createWidget(connectConfigure, {
      searchParameters: this.searchParameters
    });
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.searchParameters.firstChange) {
      this.getHelper().clearRefinements();
      this.state.refine(changes.searchParameters.currentValue);
    }
  }
}
